<template>
    <div class="wrapper" style="background-color:#fff;">

        <Sidebar />

        <div class="container container-fix" :style="{ 'margin-left': sidebarWidth }">

            <div class="col-12 ">
                <div class="top" style="height:60px;"> </div>

                <h4 class="mb-6 font-semibold">Upload Contract</h4>

                <div class="bg-gray-100 min-h-screen flex flex-col  p-4 rounded-xl">

                    <small>
                        If your Client or Sub-Contractor prefers to manually sign the agreement instead of signing it electronically, you can upload a scanned copy of the signed agreement below. Our system will read the associated QR code in the agreement and upload it to the correct section automatically. <br >Note: Your Client or Sub-Contractor must scan either a PDF or Image type file.
                    </small>

                    <div class="box">
                        <div class="upload-area"
                             @dragover.prevent
                             @drop.prevent="handleDrop"
                             @dragenter="isDragging = true"
                             @dragleave="isDragging = false">
                            <input type="file" ref="myfile" accept="image/*,.pdf" @change="onFileChange" />
                            <p v-if="!isDragging && !contract" class="upload-message">Drag & Drop your files here or</p>
                            <p v-if="isDragging" class="drag-message">Drop the file to upload</p>
                            <button @click="$refs.myfile.click()" class="browse-button">Browse files</button>
                        </div>


                    </div>
                </div>
            </div>

            <CustomPopup :visible="showPopup"
                         :icon="popupIcon"
                         :iconSrc="popupIconSrc"
                         :iconColor="iconColor"
                         :title="popupTitle"
                         :content="content"
                         :cancelText="cancelText"
                         :confirmText="confirmText"
                         :confirmButtonType="confirmButtonType"
                         :confirmAction="currentConfirmAction"
                         @cancel="onCancel" />
        </div>
    </div>
</template>

<script>
    import Sidebar from '../components/siderbar/SidebarComponent';
    import { sidebarWidth } from '../components/siderbar/state';
    import CustomPopup from '../components/modals/CustomPopup.vue';

    export default {
        components: {
            Sidebar, CustomPopup
        },
        setup() {
            return { sidebarWidth }
        },
        data() {
            return {
                contract: null,
                isDragging: false,


                //Custom Popup
                showPopup: false,
                popupIcon: null, // Set to null since we'll use an image
                popupIconSrc: '', // Use this variable to hold the image path
                iconColor: '',
                popupTitle: '',
                content: '',
                cancelText: '',
                confirmText: '',
                confirmButtonType: 'primary',
                currentConfirmAction: null,
            }
        },
        methods: {

            popupMessage(title, msg) {
                this.showPopup = true;
                this.iconColor = 'red';
                this.popupIconSrc = require('@/assets/images/icons/ErrorIcon.png');

                this.popupTitle = title;
                this.content = msg;
                this.cancelText = null;
                this.confirmText = 'OK';
                this.confirmButtonType = 'error';
                this.currentConfirmAction = () => {
                    this.showPopup = false;
                };        
                        
            },

            onFileChange(event) {
                const file = event.target.files[0];
                if (file) {
 

                    if (!file.type.startsWith('image/') && file.type != 'application/pdf') {
                        event.target.value = '';
                        this.popupMessage(`Error`, `Please attach only PDF or Image files.`);
                        return;
                    }

                    if (file.size > 15 * 1024 * 1024) {
                        event.target.value = '';
                        this.popupMessage(`Error`, `File ${file.name} exceeds 15MB file size limit.`);
                        return;
                    }

                    this.contract = file;

                    this.upload(true, file);
                }
            },
            handleDrop(event) {
                this.isDragging = false;
                const file = event.dataTransfer.files[0];

                //console.log("file", file);
                if (file) {

                    if (!file.type.startsWith('image/') && file.type != 'application/pdf') {
                        event.target.value = '';
                        this.popupMessage(`Error`, `Please attach only PDF or Image files.`);
                        return;
                    }

                    if (file.size > 15 * 1024 * 1024) {
                        event.target.value = '';
                        this.popupMessage(`Error`, `File ${file.name} exceeds 15MB file size limit.`);
                        return;
                    }

                    this.contract = file;

                    this.upload(true, file);
                }
            },
            upload(isConfirmed, file) {
                  
                let postdata = new FormData();
                postdata.append('file', file);
                this.$loader.show(null, 120);
                this.$http.request("post", `/api/app/barcode/scandocuments?isConfirmed=${isConfirmed}`, postdata).then((res) => {

                    console.log("scandocuments", res);

                    if (res?.Type == 200) {
                        this.contract = res.Data;
                       
                        let obj = res.Data;
                        this.$refs.myfile.value = null;


                        this.showPopup = true;

     
                        this.iconColor = 'red';
                        this.popupIconSrc = require('@/assets/images/icons/SuccessIcon.png');

                        this.popupTitle = "Success";
                        this.content = "Contract successfully uploaded!";
                        this.cancelText = null;
                        this.confirmText = 'OK';
                        this.confirmButtonType = 'success';
                        this.currentConfirmAction = () => {
                            this.showPopup = false;
                            this.$router.push('/MyProjects');
                        };

                        
 
                    } else {

                        this.showPopup = true;
                         
                        this.iconColor = 'red';
                        this.popupIconSrc = require('@/assets/images/icons/ErrorIcon.png');

                        this.popupTitle = "Error";
                        this.content = res.Content;
                        this.cancelText = null;
                        this.confirmText = 'OK';
                        this.confirmButtonType = 'error';
                        this.currentConfirmAction = () => {
                            this.showPopup = false;
                        };

                      
                         
                    }
                }).finally(() => {
                    this.$loader.hide();
                });
                     
            },
            onCancel() {
                this.showPopup = false;
            },
        }
    }
</script>

<style scoped>

    .container-fix {
        border-radius: 8px;
        min-height: 100vh;

    }

    .title {
        font-weight: 800;
        margin-left: 10px;
        padding-left: 0px;
      
    }

    .description {
        margin-left: 10px;
        font-size: 14px;
        color: #666;
    }

    .box {

        padding: 20px;
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        max-width: 600px;
        margin: 32px auto;
    }

    .upload-area {
        border: 2px dashed #ccc;
        border-radius: 10px;
        padding: 40px;
        text-align: center;
        cursor: pointer;
        background-color: #f8f8f8;
    }

        .upload-area input[type="file"] {
            display: none;
        }

    .upload-message,
    .drag-message {
        font-size: 16px;
        margin-bottom: 10px;
        color: #666;
    }

    .drag-message {
        color: #009688;
    }

    .browse-button {
        background-color: #28a745;
        color: #fff;
        padding: 10px 20px;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        transition: background-color 0.3s;
    }

        .browse-button:hover {
            background-color: #218838;
        }

    .file-preview {
        margin-top: 20px;
    }

    .file-name {
        font-size: 14px;
        color: #333;
        margin-bottom: 10px;
    }

    .btn-positive {
        background-color: #28a745;
        color: #fff;
        padding: 10px 20px;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        transition: background-color 0.3s;
    }

        .btn-positive:hover {
            background-color: #218838;
        }
</style>
